var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5004,
    cy: 4.30139,
    r: 2.45959,
    transform: "rotate(90 12.5004 4.30139)",
    fill: "#757575"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5004,
    cy: 12.5006,
    r: 2.45959,
    transform: "rotate(90 12.5004 12.5006)",
    fill: "#757575"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5004,
    cy: 20.6998,
    r: 2.45959,
    transform: "rotate(90 12.5004 20.6998)",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuColumn);
export default __webpack_public_path__ + "static/media/menuColumn.510f8237677cb0f6d7d8a8dc10ab7672.svg";
export { ForwardRef as ReactComponent };